import React, { Component } from "react";
import { Card } from "react-bootstrap";
import Moment from "react-moment";
import http from "../services/HttpService";
import config from "../config.json";
import AddNewGroupDocs from "./AddNewGroupDocs";

class GroupDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      showHide: false,
      msgShowHide: false,
      msgId: 0,
      message: [],
      selectedMessage: {},
    };
  }

  async componentDidMount() {
    this.loadMessage();
  }

  handleModalShowHide = () => {
    this.setState({ showHide: !this.state.showHide });
  };

  handleMessagePopup = (message) => {
    this.setState({
      msgShowHide: !this.state.msgShowHide,
      selectedMessage: message,
    });
  };

  handleAddNewMessage = async (Msg, docs) => {
    const { WorkflowTask } = this.props;
    //console.log(Msg);
    //console.log(docs);
    const frmdata = new FormData();
    frmdata.append("task", JSON.stringify(WorkflowTask));
    frmdata.append("Msg", Msg);
    docs.map((file, key) => frmdata.append("files[" + key + "]", file.file));
    const result = await http.post(config.AddNewMessage, frmdata);
    this.handleModalShowHide();
  };

  loadMessage = async () => {
    const { WorkflowTask } = this.props;
    const { data: messaging } = await http.get(
      config.GetCommunication + WorkflowTask.ciid
    );
    //console.log(data);
    let msgUnreadCount = 0;
    messaging.map((item) => (msgUnreadCount += item.unreadCount));
    this.setState({ message: messaging, msgUnreadCount });
  };

  handleMessaging = (Msg) => {
    //console.log(Msg);
  };

  render() {
    const {
      showHide,
      msgShowHide,
      message: messaging,
      selectedMessage,
    } = this.state;

    const { WorkflowTask } = this.props;
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-sm btn-default"
          onClick={this.handleModalShowHide}
        >
          <i className="fa fa-plus mr-2" aria-hidden="true" />
          Add New Group
        </button>
        <div className="table-responsive">
          <table className="table table-striped align-items-center table-flush">
            <thead className="thead-light-green">
              <tr>
                <th>S.No</th>
                <th>Date & Time</th>
                <th>Group</th>
                <th>Documents</th>
                <th>Created By</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {messaging.length > 0 &&
                messaging.map((item) => (
                  <tr>
                    <td>{item.id}</td>
                    <td>
                      <Moment format="MMMM Do YYYY, h:mm A">
                        {item.addedDateTime}
                      </Moment>
                    </td>
                    <td>{item.receiver}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-default"
                        onClick={() => this.handleMessagePopup(item)}
                      >
                        View/Reply
                      </button>
                    </td>
                    <td>{item.createdBy}</td>
                    <td>{item.role}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <AddNewGroupDocs
          showHide={showHide}
          handleModalShowHide={this.handleModalShowHide}
          handleAddNewMessage={this.handleAddNewMessage}
          WorkflowTask={WorkflowTask}
        ></AddNewGroupDocs>
      </React.Fragment>
    );
  }
}

export default GroupDocuments;
